import React from 'react'
import { Row, Container, ListGroup } from 'react-bootstrap'
import { Helmet } from 'react-helmet'

const Privacy = () => {
  return (
    <>
      <Helmet>
        <title>隱私權政策 | KOLSTAR</title>
      </Helmet>
      <main className="privacy m-4">
        <Container>
          <Row>
            <h2 className="fw-bold">隱私權政策</h2>
            <span>
              典通股份有限公司（以下簡稱「本公司」）非常重視使用者在使用本公司所營運之
              KOLSTAR
              平台（以下簡稱為「本平台」）提供服務時的隱私權，以下是本公司詳細的隱私權政策（以下簡稱「本政策」）且符合歐盟「通用資料保護規則」（GPDR）規範，當使用者同意授權使用本平台時，即表示使用者同意我們依照本隱私權政策蒐集、處理及利用使用者的個人資料。
            </span>
            <ListGroup variant="flush" className="my-3">
              <ListGroup.Item action>
                <h5 className="fw-bold">一、總則</h5>
                <ol>
                  <li>所有本公司提供之服務及內容均受本政策規範。</li>
                  <li>
                    本政策將因應需求或法令變更而隨時進行修正，修正版本將公告並刊登於本平台之「隱私權政策」連結，為確保使用者的權益，建議使用者定期關心最新公告與本政策之變動。
                  </li>
                </ol>
              </ListGroup.Item>
              <ListGroup.Item action>
                <h5 className="fw-bold">二、資料蒐集之個人資料類別</h5>
                <ol>
                  <li>
                    我們會蒐集您使用本服務時所提供的內容和其他資訊，其中包含申請帳號，及其他您所提供之資料。
                  </li>
                  <li>
                    我們蒐集資訊是為了向所有利用本平台的使用者提供更優質的服務，這些資訊可協助我們分析較複雜的內容，並提供使用者數據分析服務（例如：貼文互動數據、粉絲互動數據等）。我們會將蒐集自本平台的資訊用於提供、維持、保護與改善本服務、開發新的服務。我們也會運用這些資料，提供數據儀表板、成效分析，協助所有使用者優化使用成效。
                  </li>
                  <li>
                    我們會將蒐集自本平台的資訊用於提供、維持、保護與改善本服務、開發新的服務、進行客戶管理、會員管理及行銷與內部的統計調查與分析使用。我們也會運用這些資料，提供數據儀表板、成效分析，協助所有使用者優化使用成效。根據中華民國個人資料處理法，我們將蒐集之個人資料類別如下：
                    <ul className="square">
                      <li>
                        C001
                        個人辨識（例如：使用者之姓名、帳號、工作地址、相片、電話號碼等）
                      </li>
                      <li>
                        C011 個人描述（例如：年齡、性別、出生年月日、國籍等）
                      </li>
                      <li>
                        C035 休閒活動及興趣（例如：嗜好、運動及其他興趣等）
                      </li>
                      <li>C036 生活格調：如：消費模式等。</li>
                      <li>C038 職業：各種職業</li>
                      <li>C052 資格或技術：如學歷資格等</li>
                      <li>C073 安全細節（例如：密碼）</li>
                      <li>
                        C092
                        資料主體提供之財貨或服務（例如：貨物或服務之有關細節）
                      </li>
                      <li>
                        C101
                        資料主體之商業活動（例如：商業種類、提供或使用之財貨或服務、商業契約）
                      </li>
                      <li>
                        C102
                        約定或契約（例如：關於交易、商業、法律或其他契約、代理）
                      </li>
                      <li>
                        C132
                        未分類之資料（例如：備註、無法歸類之檔案、報告、留言、評論）
                      </li>
                      <li>
                        電腦與行動應用裝置之資料，含軟硬體規格、裝置辨識資料、IP
                        位址、COOKIE 與裝置地理位置。
                      </li>
                    </ul>
                  </li>
                </ol>
              </ListGroup.Item>
              <ListGroup.Item action>
                <h5 className="fw-bold">三、資料使用目的及利用方式</h5>
                <span>
                  本平台及本服務所蒐集之個人資料將出於下列目的而使用：
                </span>
                <ul className="square">
                  <li>〇四〇 行銷（包含金控共同行銷業務）</li>
                  <li>〇六九 契約、類似契約或其他法律關係事務</li>
                  <li>〇九〇 消費者、客戶管理與服務</li>
                  <li>〇九一 消費者保護</li>
                  <li>〇九八 商業與技術資訊</li>
                  <li>一三五 資（通）訊服務</li>
                  <li>一三六 資（通）訊與資料庫管理</li>
                  <li>一四八 網路購物及其他電子商務服務</li>
                  <li>一五二 廣告或商業行為管理</li>
                  <li>一五七 調查、統計與研究分析</li>
                  <li>一八一 其他經營合於營業登記項目或組織章程所定之業務</li>
                </ul>
                <span>
                  本平台將以自動化、人工或委託第三方資料分析公司方式處理使用者的資料，並妥善保護資料之匿名性與安全。
                </span>
              </ListGroup.Item>
              <ListGroup.Item action>
                <h5 className="fw-bold">四、資料蒐集之管道</h5>
                <span>本平台及本服務蒐集資訊之管道如下：</span>
                <ol>
                  <li>
                    使用者主動提供的資訊：使用者運用本平台所上傳的文字、圖片等資訊
                  </li>
                  <li>
                    我們經由使用者使用本平台及本服務而取得的資訊：針對使用者使用的服務和使用方式蒐集相關資訊，包括：
                    <ul>
                      <li>
                        裝置資訊：
                        <br />
                        我們會蒐集裝置專屬資訊。（例如：使用者的硬體型號、作業系統版本、裝置的唯一識別碼）
                      </li>
                      <li>
                        記錄資訊：
                        <br />
                        當使用者使用本平台時，我們會自動蒐集特定資訊並儲存在伺服器紀錄中。這類資訊包括：
                        <ul>
                          <li>
                            操作歷程，包括但不限於：操作行為、編輯內容、發布時間等
                          </li>
                          <li>網際網路通訊協定位址</li>
                          <li>
                            裝置活動資訊，例如：當機資料、系統活動、硬體設定、瀏覽器類型、瀏覽器語言、使用者提出要求的日期和時間，以及參照連結網址等
                          </li>
                        </ul>
                      </li>
                      <li>
                        本機存放區：
                        <br />
                        我們會運用瀏覽器網路存放區（包括
                        HTML5）和應用程式資料快取等機制，蒐集資訊（包括個人資訊）並將其儲存在使用者的裝置本機中。
                      </li>
                      <li>
                        Cookie： <br />
                        Cookie
                        是內含一串字元的小檔案，由網站在使用者造訪時傳送到使用者的電腦。當使用者再次瀏覽同一個網站時，該網站就能透過
                        Cookie 辨識使用者的瀏覽器。
                      </li>
                    </ul>
                  </li>
                </ol>
              </ListGroup.Item>
              <ListGroup.Item action>
                <h5 className="fw-bold">五、資料保護</h5>
                <span>
                  只有在以下情況，本公司會與第三方公司、機構或個人分享使用者的資料：
                </span>
                <ol>
                  <li>徵得使用者的同意</li>
                  <li>基於法律原因</li>
                  <li>
                    應政府機關、司法機關經合法正式的程序要求本公司公開特定個人資料時，以及對本平台及本服務所有使用者安全考量下做必要的配合
                  </li>
                  <li>本公司為行使法律上的權利或對訴訟上之請求提出防禦</li>
                  <li>
                    本公司為了調查或防止非法活動、詐欺行為、對使用者或第三人人身安全有潛在威脅之情況或違反本公司網站使用者服務條款採取之應對措施
                  </li>
                  <li>
                    如果本公司全部或部份業務被其他公司收購或合併，本公司會將使用者的個人資料移轉給該公司，而本公司將儘可能在使用者的個人資料被移轉且將適用於該公司不同的隱私權政策前通知使用者。
                  </li>
                </ol>
              </ListGroup.Item>
              <ListGroup.Item action>
                <h5 className="fw-bold">六、資訊安全</h5>
                <span>
                  本公司非常重視使用者的資料安全，我們採取了許多措施來保護使用者的資料。
                </span>
                <ol>
                  <li>
                    本平台使用 SSL 加密，提供資料傳輸安全及資料完整性保障。
                  </li>
                  <li>
                    本網站主機均設有防火牆、防毒系統等相關的各項資訊安全設備及必要的安全防護措施，加以保護網站及您的個人資料採用嚴格的保護措施，所有因業務需求能接觸到使用者資訊的相關人員，包含但不限於員工、合作廠商、承包商等，皆須簽訂保密條款，並遵守規範，一旦發現有不符規定的行為，本公司將採取懲罰或解約等處分。
                  </li>
                </ol>
              </ListGroup.Item>
              <ListGroup.Item action>
                <h5 className="fw-bold">七、個人資料保護政策</h5>
                <ol>
                  <li>
                    對於您在本服務所登錄的個人資料及使用記錄，我們將採取適當步驟，盡商業尚合理之努力確保資料儲存於本服務系統中的安全性。
                  </li>
                  <li>
                    使用者本人可查詢、複製、請求閱覽或申請變動屬於使用者的帳戶資料，前述權利僅限使用者本人或得使用者授權之人行使。為善盡保護使用者的帳戶資料之責，必要時本公司將會要求申請人提供相關資料，使本公司可驗證使用者身份。
                  </li>
                  <li>
                    於使用者使用本平台期間，本公司將保存使用者的帳戶資料。使用者本人可要求停止利用或刪除其帳戶資料；但一經停止或刪除，使用者將無法繼續使用本平台。
                  </li>
                  <li>
                    於妨害國家重大利益、妨害公務機關執行法定職務、妨害蒐集機關或第三人重大利益時，本公司有權拒絕使用者主動提出變更、刪除或異動個人資料之請求。
                  </li>
                  <li>
                    依據個人資料保護政策及保護會員權益的立場，如要終止本公司蒐集、分析、使用或刪除您的個人資料，可透過：
                    <a href="mailto:po@dsigroup.com.tw">po@dsigroup.com.tw</a>{' '}
                    此電郵信箱，或撥打公司電話
                    (02)2331-5133(分機703)，向本公司客服進行申請。申請過程中，可能會需要您提供身分證件或其他證明文件予本公司客服單位，作身份比對及驗證之用。
                  </li>
                </ol>
              </ListGroup.Item>
              <ListGroup.Item action>
                <h5 className="fw-bold">八、免責條款</h5>
                <ol>
                  <li>
                    本平台是提供使用者進行 AI 社群成效經營分析、AI
                    顧客分析與資訊檢索服務，方便使用者進行顧客管理、行銷推廣、政策推廣及需求收集等活動，使用者明白於使用本服務過程中，有需要蒐集、使用與本服務機互動之顧客的個人資料，使用者有義務使顧客知悉其個人資料（包括但不限於：與該粉絲專頁之按讚、留言、分享、對話、連結點擊等）將被蒐集、利用及處理，使用者並應取得其同意，由使用者負擔完全責任，與本公司無關。
                  </li>
                  <li>
                    如使用者之顧客或潛在顧客因個人資料爭議向本公司請求賠償或本公司因此遭主管機關裁罰，使用者同意依法賠償本公司因此所受一切損失。
                  </li>
                </ol>
              </ListGroup.Item>
              <ListGroup.Item action>
                <h5 className="fw-bold">九、隱私權政策修訂與效力</h5>
                <ol>
                  <li>
                    本公司保留在不通知使用者的情況下，得於修訂本政策後公布於本平台的適當位置，不另行個別通知。我們建議使用者可以隨時點擊
                    KOLSTAR平台中的「隱私權政策」連結，檢視最新版本，以確認本政策是否有修改。
                  </li>
                  <li>
                    本政策構成本平台服務條款的一部分。如使用者不同意本政策之任何條款或修改後變更之內容，請使用者立即停止使用本平台之服務。
                  </li>
                  <li>
                    當您於隱私權政策任何修改或變更後，繼續使用本服務，表示您已閱讀、瞭解並同意接受隱私權政策修改後之內容。
                  </li>
                  <li>
                    如果使用者對本平台之隱私權或個人資料保護政策有任何問題，請聯絡：
                    <a href="mailto:po@dsigroup.com.tw">po@dsigroup.com.tw</a>
                    ，或撥打公司電話 (02)2331-5133(分機703)。
                  </li>
                </ol>
              </ListGroup.Item>
              <ListGroup.Item action>
                <h5 className="fw-bold">十、準據法及管轄</h5>
                <span>
                  本隱私權政策條款以中華民國法律為準據法。任何因本隱私權政策及/或您使用本服務所生之爭議，應與我們聯繫並盡力秉持善意解決，我們將盡一切努力秉持善意與您解決所有爭議。若無法於
                  30
                  日內達成解決方案之合意，您同意中華民國台北地方法院有第一審專屬管轄權。
                </span>
              </ListGroup.Item>
              <ListGroup.Item className="text-end" action>
                <span>本文最後更新時間：2021-10-28</span>
              </ListGroup.Item>
            </ListGroup>
          </Row>
        </Container>
      </main>
    </>
  )
}

export default Privacy
